import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
import { createStack } from '@famly/mf_layout_stack';
import { useDataProps } from '@famly/mf_ts-utils_data-aria-props';
import Button from 'web-app/react/components/form-elements/button/button';
import FormInput from 'web-app/react/components/form-elements/containers/form-input';
import { media } from 'web-app/styleguide/utils';
import AnimatedCheckmark from 'web-app/react/components/animated-checkmark/animated-checkmark';
import LoginChrome from './login-chrome';
export const LoginContainer = styled('div') `
    width: 320px;
    max-width: calc(100vw - 48px);
    ${media.mobileSideways `
        width: 320px;
        ${props => props.wide
    ? css `
                      width: 320px;
                  `
    : ''}
    `}
    ${media.notLandscape `
        @media (max-height: 600px) {
            width: 280px;
        }
    `}
`;
export const LoginTextFieldCSS = css `
    border: none;
    border-radius: 0;
    background-image:
        ${props => `linear-gradient(${props.activeColor ? props.theme[props.activeColor] : props.theme.active}, ${props.activeColor ? props.theme[props.activeColor] : props.theme.active})`},
        ${props => `linear-gradient(${props.passiveColor ? props.theme[props.passiveColor] : props.theme.delimiter}, ${props.passiveColor ? props.theme[props.passiveColor] : props.theme.delimiter})`};
    background-size:
        0 2px,
        100% 1px;
    background-position:
        left bottom,
        left calc(100% - 1px);
    background-repeat: no-repeat;
    background-color: transparent;
    padding: 16px 0;
    height: auto;
    font-size: ${props => props.theme.fontConfiguration.sizes.Subheader};
    margin-bottom: 0;
    &:focus {
        border: none;
        background-size:
            100% 2px,
            100% 1px;
    }

    &,
    &:focus {
        transition: background-size 200ms ${props => props.theme.timings.functions.default};
    }
`;
export const LoginFormTextField = styled(FormInput).withConfig({
    // `activeColor` / `passiveColor` are style-only props consumed by LoginTextFieldCSS. Without
    // this, styled-components forwards them through FormInput -> TextField -> the native <input>,
    // producing React "does not recognize the `activeColor` prop on a DOM element" warnings.
    shouldForwardProp: prop => prop !== 'activeColor' && prop !== 'passiveColor',
}) `
    ${LoginTextFieldCSS}

    ${props => props.hidden
    ? css `
                  display: none;
              `
    : ''}
`;
export const LoginButtonStyle = css `
    width: 100%;
    padding-top: 0;
    padding-bottom: 0;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${props => props.theme.fontConfiguration.sizes.Subheader};
    font-weight: 600;
`;
export const SubmitButton = styled(Button).attrs(() => ({
    appearance: 'confirm',
})) `
    ${LoginButtonStyle}
`;
export const SimpleLoginChrome = (props) => {
    const dataProps = useDataProps(props);
    return (_jsx(LoginChrome, { locale: props.locale, children: _jsx(LoginContainer, { ...dataProps, children: _jsxs(ContentWrapper, { children: [props.showGreenCheckMark ? _jsx(StyledAnimatedCheckmark, { animateCircle: true }) : null, _jsx(InnerContentWrapper, { children: props.children })] }) }) }));
};
const ContentWrapper = styled(createStack({})) `
    ${media.mobile `
        && {
            flex-direction: column;
            align-items: center;
        }
    `}
`;
const InnerContentWrapper = styled(createStack({ direction: 'column', justifyContent: 'space-between' })) `
    ${media.mobile `
        align-items: center;
        text-align: center;
    `}
`;
const StyledAnimatedCheckmark = styled(AnimatedCheckmark) `
    max-width: 100px;
    margin-right: 16px;
    circle,
    path {
        stroke: ${props => props.theme.accent1};
    }
    ${media.mobile `
        margin-bottom: 16px;
        margin-right: 0;
    `}
`;
